import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const TrailRunners: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 32.85 43.45">
            <g>
                <path fill={color} d="M29.15,41.58l-2.57-9.53-9.25-9.26v-10.71l3.95,4.86,6.75.08,1.95-1.84-7.81-.1-4.85-5.97v-1.83h-1.86v.9h-.08c-.93,0-1.83.39-2.46,1.07-.26.28-.47.6-.62.94l-4.93,2.2v9.52l1.86-1.76v-6.55l2.82-1.26.52,8.07h2.89v3.16l-4.21,8.29-11.25.03v4.05l1.86,1.1v-3.29l10.53-.02,4.46-8.78,8.05,8.06,2.81,10.43h5.13v-1.86h-3.7ZM15.46,18.56h-1.14l-.44-6.89c-.03-.42.12-.82.41-1.13.29-.31.68-.48,1.1-.48h.08v8.5Z"/>
                <path fill={color} d="M16.39,6.13c1.69,0,3.06-1.37,3.06-3.06s-1.37-3.06-3.06-3.06-3.06,1.37-3.06,3.06,1.37,3.06,3.06,3.06ZM16.39,1.86c.66,0,1.2.54,1.2,1.2s-.54,1.2-1.2,1.2-1.2-.54-1.2-1.2.54-1.2,1.2-1.2Z"/>
            </g>
        </svg>
    );
};

export default TrailRunners;
